var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({},'div',_vm.wrapperProps,false),[_c('img',_vm._b({attrs:{"src":_vm.src}},'img',_vm.imageProps,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }